import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { MetaReducer, StoreModule } from '@ngrx/store';

import { CurrencyPipe } from '@angular/common';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { LoginStateFacade } from '@rci/self-serve-fido/core/fido-login-state/login-state.facade';
import { BillingAlertsEffects } from '@rci/self-serve-fido/shared/billing-alerts/effects';
import { CustomDatePipe } from '@rogers/self-serve-utils/custom-date';
import { CookieService } from 'ngx-cookie-service';
import { globalEffectsList } from './app.effects';
import { AppFacade } from './app.facade';
import { globalReducers } from './app.reducers';
import { SelfServeAppState } from './app.state.model';
import { ContactDetailStoreModule } from './contact-detail';
import { CustomSerializer, stateInitializer } from './init.store';

export const metaReducers: MetaReducer<SelfServeAppState>[] = [];

@NgModule({
  imports: [
    StoreModule.forRoot(globalReducers, {
      metaReducers,
      runtimeChecks: { strictStateImmutability: true, strictActionImmutability: true },
    }),
    EffectsModule.forRoot(globalEffectsList),
    StoreRouterConnectingModule.forRoot({
      serializer: CustomSerializer,
    }),
    ContactDetailStoreModule,
    EffectsModule.forFeature([BillingAlertsEffects]),
  ],
  exports: [StoreModule, EffectsModule, StoreRouterConnectingModule],
  providers: [...stateInitializer, AppFacade, LoginStateFacade, CookieService, CustomDatePipe, CurrencyPipe],
})
export class AppStoreModule {}
